import ApiGrid from './ApiGrid'

ApiGrid.install = function install (Vue) {
  Vue.component(ApiGrid.name, ApiGrid)
}

export default ApiGrid



// WEBPACK FOOTER //
// ./src/components/api-grid/index.js